<template>
    <div class='list-tab-wrapper pointer primary-text-21 card-bg-f1 ' :class='{"active":checked,"had-read":!checked && hadRead}'>
        <div class='title'>
            {{title}}
        </div>
        <div class='footer sub-text-88'>
            <div class='footer-tag'>{{leftSlot}}</div>
            <div class='footer-time'>{{rightSlot}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'listTab',
    data() {
        return {
            testTittle: 'aaaaa'
        }
    },
    props: ['title', 'rightSlot', 'leftSlot', 'checked', 'hadRead'],
    computed: {
    },
    beforeCreate: function () {
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
    }
}
</script>
<style lang="less" scoped>
@import '../../common/style/index.less';
.list-tab-wrapper {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 10px 10px 10px;
    // cursor: pointer;
    .title {
        height: 42px;
        line-height: 21px;
        font-size: 14px;
        .mul_ell(2);
    }
    .footer {
        display: flex;
        padding-top: 6px;
        box-sizing: border-box;
        justify-content: space-between;
        font-size: 12px;
        height: 22px;
    }
}

.had-read {
    .title {
        color: #888c8e !important;
    }
    .footer {
        .footer-time {
            color: #888c8e !important;
        }
    }
}
.night {
    .had-read {
        .title {
            color: #5d6265 !important;
        }
        .footer {
            .footer-time {
                color: #5d6265 !important;
            }
        }
    }
}
.active {
    border-left: 3px solid #fd4332;
    padding: 9px 10px 9px 7px;
    background-color: #fafafa !important;
    border-right: 1px solid #f1f1f1;
    border-top: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    .title {
        // color: #999;
    }
    .footer {
        .footer-time {
            // color:#999;
        }
        .footer-tag {
            opacity: 0.6;
        }
    }
}
.night {
    .active {
        background: #4c4c4c !important;
        padding: 10px 10px 10px 7px;
        border-right: 0;
        border-top: 0;
        border-bottom: 0;
        .title {
            color: #eee !important;
        }
        .footer {
            .footer-time {
                color: #5d6265 !important;
            }
            .footer-tag {
                opacity: 0.6;
            }
        }
    }
}
.profitable {
    color: @profitable;
}
.unprofitable {
    color: @unprofitable;
}
.normal {
    color: @normal;
}
</style>
